import React, { Component } from 'react'

export default class Alert extends Component {

    CloseFx = () => {

        this.props.closeMe()
    
    }

    render() {

        return (
            
            <div className='NightWrapper' onClick = {this.CloseFx}>

                <p id='Denied'>{this.props.alert}</p>

            </div>
        )

    }

}



// WEBPACK FOOTER //
// ./src/components/etc/Alert.js